import { render } from "./post1Page.vue?vue&type=template&id=7f688efa"
import script from "./post1Page.vue?vue&type=script&lang=js"
export * from "./post1Page.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__